<template>
  <orders-view />
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import OrdersView from "@/client/applications/justopp/views/Orders";

export default {
  components: { OrdersView },
  layout: {
    component: "UserDashboardInner",
    params: {
      title: "justopp.orders.pageTitle",
      subTitle: "justopp.orders.pageSubtitle",
      backButton: true,
    },
  },
  middleware: {
    requireUser: {},
    requireNotVendor: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "admin.orders.pageTitle",
  data: function () {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
